import { judgeDeviceType } from "./device"
import { getQueryString } from "@/utils/location";
import to from 'await-to-js';

/** 时/分/秒 转为 HH:MM:SS */
export function unitFormat(value: number) {
  return value > 0 ? `${ value < 10 ? '0' : '' }${ value }` : '00'
}

/** 将 秒钟 转化为 hh:mm:ss 格式 */
export function formatDuration(duration: number) {
  if (duration === 0) return '00:00'
  // 毫秒转成秒
  duration = Math.ceil(duration / 1000)
  // 计算小时、分钟的剩余时长
  let restDuration = duration
  // 小时
  const hours = Math.floor(restDuration / (60 * 60))
  restDuration = restDuration % (60 * 60)
  // 分钟
  const minutes = Math.floor(restDuration / (60))
  restDuration = restDuration % (60)
  // 秒钟
  const seconds = restDuration < 1 ? 1 : Math.floor(restDuration)
  return `${
    hours > 0 ? unitFormat(hours) : ''
  }${
    hours > 0 ? ':' : ''
  }${
    unitFormat(minutes)
  }:${
    unitFormat(seconds)
  }`
}

export function hasDecimal(num) {
  return /\./.test(num.toString());
}

/**
 * 判断值是否为空
 * @param str 
 * @returns 
 */
export function isNull(str) {
  if (!str || str === 'null' || str === 'undefined') {
    return true
  }
  return false
}

/** 将 Object 类型转换为拼在 url 后面的参数串 */
export function changeOptionsToParams(options, isFirst = true) {
  const result = []
  for (const key in options) {
    result.push(`${ key }=${ options[key] }`)
  }
  return JSON.stringify(options) !== '{}' ? `${ isFirst ? '?' : '&' }${ result.join('&') }` : ''
}

/** 复制 */
export function copyText(text: string) {
  return new Promise((resolve, reject) => {
    const textareaEl = document.createElement('textarea')
    textareaEl.setAttribute('readonly', 'readonly')
    textareaEl.value = text
    document.body.appendChild(textareaEl)
    textareaEl.select()
    const res = document.execCommand('copy')
    document.body.removeChild(textareaEl)
    if (res) {
      resolve(true)
    } else {
      reject(false)
    }
  })
}
/**
   * 获取讲真是否显示开关
   */
export function _getSwitch(that) {
  return new Promise((resolve, reject) => {
    that.$http('getSwitch').then(res => {
      if (res.code === 200) {
        resolve(res.data)
      } else {
        reject('res code not 200')
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
   * 获取用户信息
   * @returns
   */
export function _getUserInfo(that) {
  return new Promise((resolve, reject) => {
    that.$http('getUserInfo').then(res => {
      if (res.code === 200 && res.data ) {
        resolve(res.data)
      } else {
        reject(res)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
/**
   * 是否是讲真来源
   */
export function isJZYCD(resource: string) {
  const str = resource.toLocaleUpperCase();
  return str.indexOf('JZ') !== -1;
}
export function getDouyinAccessToken(that) {
  return new Promise((resolve, reject) => {
    that.$http('getDouyinAccessToken', {
      "appid": "tte04b96f67f7a444601",
      "secret": "102494aa28df0dcea682f8d38513d174b55a9548",
      "grant_type": "client_credential"
    }).then(res => {
      if (res.code === 200) {
        // const access_token = res.data && res.data.access_token || ''
        const access_token = res.atoken || ''
        resolve(access_token)
      } else {
        reject('res code not 200')
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * 抖音内容安全检测
 */
export function checkDouyinTextContent(that, content) {
  return new Promise(async (resolve, reject) => {
    const [error, access_token] = await to(getDouyinAccessToken(that));
    if(error || !access_token)  {
        reject('获取access_token失败');
    }
    that.$http('checkDouyinTextContent', {
      atoken: access_token, //小程序 access_token
      content: content
      // tasks: [ // 检测任务列表
      //   { content: content }, //检测的文本内容
      // ]
    }).then(res => {
      if (res.code === 200) {
        const resData = res.data || {};
        const hit = resData[0] && resData[0].predicts && resData[0].predicts[0] && resData[0].predicts[0].hit;
        if (resData.error_id) {
          reject('抖音内容检测失败');
        }else if (hit) { //违规
          resolve(true);
        }else {
          resolve(false);
        }
      } else {
        reject('获取抖音内容检测失败');
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
/**
 * 抖音图片安全检测
 */
export function checkDouyinImgContent(that, data: { image?: string, image_data?: string }) {
  return new Promise(async(resolve, reject) => {
    const [error, access_token] = await to(getDouyinAccessToken(that));
    if(error || !access_token)  {
        reject('获取access_token失败');
    }
    const params = {
      app_id:'tte04b96f67f7a444601',
      access_token: access_token, //小程序 access_token
      image: data.image, // 检测的图片链接
      image_data: data.image_data, // 图片数据的 base64 格式，有 image 字段时，此字段无效
  }
  if(params.image_data) delete params.image; 
    that.$http('checkDouyinImgContent', params).then(res => {
      if (res.code === 200) {
        if (res.data && res.data.error !== 0) { //违规
          resolve(true);
        } else {
          resolve(false);
        }
      } else {
        reject('获取抖音图片检测失败');
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

export async function checkTextContent(that, content) {
  if (getQueryString('platform') === 'tt' || getQueryString('source') === 'tt') {
    const [error, checkRes] = await to(checkDouyinTextContent(that, content))
    if (!error && checkRes) {
      that.$toast('文案存在风险，请重新输入');
      return true;
    }
  }
  return false;
}
export async function checkImgContent(that, data: { image?: string, image_data?: string }) {
  if (getQueryString('platform') === 'tt') {
    const [error, checkRes] = await to(checkDouyinImgContent(that, data))
    if (!error && checkRes) {
      that.$toast('图片存在风险，请重新上传');
      return true;
    }
  }
  return false;
}

export function toNewPage(path: string = '') {
  const linkUrl = window.location.origin + `/#/${path}`;
  if (this.isApp) {
    let switchWebviewUrl = (<any>window).switchWebviewUrl;
    switchWebviewUrl.postMessage(linkUrl + (path.includes('?') ? '&' : '?') + 'open=true');
  } else if(typeof this.$navigateTo === 'function'){
    this.$navigateTo({
      url: '/pages/webview/webview?url=' + encodeURIComponent(linkUrl),
    })
  } else {
    window.location.href = linkUrl;
  }
}
/**
 * 跳转app登录页面
 */
export function toAppLogin() {
  const switchToLogin: any = (<any>window).switchToLogin
  switchToLogin.postMessage('')
}
/**
 * 跳转app登录页面带参数
 * @param params
 */
export function toAppLoginParams(params) {
  const switchToLoginWithParams: any = (<any>window).switchToLoginWithParams
  switchToLoginWithParams.postMessage(JSON.stringify(params))
}
/**
 * ai工具跳转登录页面
 */
export function aiToLogin(path) {
  const isApp = judgeDeviceType.isAPP; // 是否是APP
  if (isApp) {
    toAppLogin()
  } else {
    window.taroRawSdk.miniProgram.redirectTo({
      url: `/pages/login/login?from=${ 'AITool' }&redirect=${ path }&timestamp=${ new Date().getTime() }`
    })
  }
}

/**
 * 跳转会员中心
 * @param param
 */
export function toAppMember(param?: string) {
  const jumpVip = (<any>window).jumpVip;
  let _param = param || ''
  jumpVip.postMessage(_param)
}
export function isPunctuationOnly(str) {
  return /^[\p{P}]+$/u.test(str);
}
